import { useEffect, useState } from 'react';

const POLL_INTERVAL = 5_000; // re-check every 5 seconds

export const useAbstractDeadline = () => {
    const [deadlinePassed, setDeadlinePassed] = useState(false);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const check = () => {
            fetch(`${process.env.REACT_APP_API_URL}/api/custom-events/abstract-deadline`)
                .then(r => r.json())
                .then(data => {
                    if (cancelled) return;
                    if (data.success && data.data.enabled && data.data.deadline) {
                        if (new Date() > new Date(data.data.deadline)) {
                            setDeadlinePassed(true);
                        }
                    }
                })
                .catch(() => {})
                .finally(() => { if (!cancelled) setChecking(false); });
        };

        check();
        const timer = setInterval(check, POLL_INTERVAL);

        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, []);

    return { deadlinePassed, checking };
};

const AbstractSubmissionClosed = () => (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-16">
        <div className="text-center max-w-md w-full">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-3">Abstract Submissions Closed</h1>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
                The deadline for abstract submissions has passed.<br />
                We are no longer accepting new submissions for KAPCON 2026.
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-800">
                For queries or late submission requests, please contact the event organizers directly.
            </div>
        </div>
    </div>
);

export default AbstractSubmissionClosed;
